import React from "react";
// import PropTypes from 'prop-types'
import MomentUtils from "@date-io/moment";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import styled from "styled-components";
import {
  createTheme,
  makeStyles,
  InputAdornment,
  Icon,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import "moment/locale/es";

const Label = styled.label`
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.05em;
  color: #ff6868;
  display: block;
  margin-bottom: 0.68em;
`;

const defaultMaterialTheme = createTheme({
  palette: {
    primary: { 500: "#9240C9" },
  },
});

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "&::before": {
      borderBottom: "1px solid #dcdcdc",
    },
    "&::after": {
      borderBottom: "2px solid #9240C9",
    },
    "&:hover": {},
    "&$focused": {
      borderColor: "#9240C9",
      "& .MuiSvgIcon-root": {
        color: "#9240C9",
      },
    },
  },
}));

const InputDate = ({ value, handleChange, label, ...rest }) => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={defaultMaterialTheme}>
      <Label>{label}</Label>
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUtils}
        locale="es"
      >
        <DatePicker
          autoOk
          value={value}
          onChange={handleChange}
          format="D MMMM, YYYY"
          variant="inline"
          InputProps={{
            classes,
            endAdornment: (
              <InputAdornment position={"end"}>
                <Icon>
                  <ArrowDropDownIcon style={{ color: "#333333" }} />
                </Icon>
              </InputAdornment>
            ),
          }}
          // rightArrowIcon={() => ArrowDropDownIcon}
          style={{ width: "100%" }}
          {...rest}
        />
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

InputDate.propTypes = {};

export default InputDate;
